import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  deleteNotification: null,
  loading: false,
  error: null,
};

const deleteNotificationSlice = createSlice({
  name: "deleteNotification",
  initialState,
  reducers: {
    fetchDeleteNotificationStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchDeleteNotificationSuccess: (state, action) => {
      state.loading = false;
      state.deleteNotification = action.payload;
      state.error = null;
    },

    fetchDeleteNotificationFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchDeleteNotificationStart,
  fetchDeleteNotificationSuccess,
  fetchDeleteNotificationFailure,
} = deleteNotificationSlice.actions;

export default deleteNotificationSlice.reducer;